import { useState, useEffect, useRef } from "react";

export function useHoverState<T extends HTMLElement>() {
  const [isHovered, setIsHovered] = useState(false);
  const ref = useRef<T>(null);

  useEffect(() => {
    const elem = ref.current;

    if (!elem) return;

    const mouseEnter = () => setIsHovered(true);
    const mouseLeave = () => setIsHovered(false);

    elem.addEventListener("mouseenter", mouseEnter);
    elem.addEventListener("mouseleave", mouseLeave);

    return () => {
      elem.removeEventListener("mouseenter", mouseEnter);
      elem.removeEventListener("mouseleave", mouseLeave);
    };
  }, []);

  return { ref, isHovered };
}
